<template>
  <div class="bonus">
    <section class="bonus-top bonus-acting" v-show="!isAward">
      <div class="get-num" v-show="nameList.length==0?true:false">等你来拿</div>

      <div class="numbers" v-show="numLength>0">
        <ul id="unfinishList">
          <li id="c6" v-bind:class="numClass[6]">
            <div class="line"></div>
          </li>
          <li id="c5" v-bind:class="numClass[5]">
            <div class="line"></div>
          </li>
          <li id="c4" v-bind:class="numClass[4]">
            <div class="line"></div>
          </li>
          <li id="c3" v-bind:class="numClass[3]">
            <div class="line"></div>
          </li>
          <li id="c2" v-bind:class="numClass[2]">
            <div class="line"></div>
          </li>
          <li id="c1" v-bind:class="numClass[1]">
            <div class="line"></div>
          </li>
          <li id="c0" v-bind:class="numClass[0]">
            <div class="line"></div>
          </li>
          <span class="yuan">元</span>
        </ul>
      </div>

      <p class="num-p" v-show="nameList.length==0?false:true">{{involvePerson}}人已获得资格</p>
    </section>

    <section class="bonus-top bonus-finish1" v-show="isAward & isGet">
      <div class="get-num">您获得了</div>

      <div class="numbers" v-show="numLength>0">
        <ul id="finishGet">
          <li id="c6" v-bind:class="numClass[6]">
            <div class="line"></div>
          </li>
          <li id="c5" v-bind:class="numClass[5]">
            <div class="line"></div>
          </li>
          <li id="c4" v-bind:class="numClass[4]">
            <div class="line"></div>
          </li>
          <li id="c3" v-bind:class="numClass[3]">
            <div class="line"></div>
          </li>
          <li id="c2" v-bind:class="numClass[2]">
            <div class="line"></div>
          </li>
          <div class="dot">
            <div class="line">
              <span></span>
            </div>
          </div>
          <li id="c1" v-bind:class="numClass[1]">
            <div class="line"></div>
          </li>
          <li id="c0" v-bind:class="numClass[0]">
            <div class="line"></div>
          </li>
          <span class="yuan">元</span>
        </ul>
      </div>

      <p class="num-p">{{involvePerson}}人瓜分 {{sumAmount}}元</p>
      <div class="btn-get" @click="getBonus">领取</div>
    </section>

    <section class="bonus-top bonus-finish2" v-show="isAward & !isGet">
      <div class="tip">来晚啦！下次请早哟~</div>
      <div class="get-num">本期人均获得</div>

      <div class="numbers" v-show="numLength>0">
        <ul id="finishNoGet">
          <li id="c6" v-bind:class="numClass[6]">
            <div class="line"></div>
          </li>
          <li id="c5" v-bind:class="numClass[5]">
            <div class="line"></div>
          </li>
          <li id="c4" v-bind:class="numClass[4]">
            <div class="line"></div>
          </li>
          <li id="c3" v-bind:class="numClass[3]">
            <div class="line"></div>
          </li>
          <li id="c2" v-bind:class="numClass[2]">
            <div class="line"></div>
          </li>
          <div class="dot">
            <div class="line">
              <span></span>
            </div>
          </div>
          <li id="c1" v-bind:class="numClass[1]">
            <div class="line"></div>
          </li>
          <li id="c0" v-bind:class="numClass[0]">
            <div class="line"></div>
          </li>
          <span class="yuan">元</span>
        </ul>
      </div>
    </section>
    <section class="bonus-block" v-show="nameList.length==0?false:true">
      <div class="bonus-title">
        <span>活动名单</span>
      </div>
      <div class="roll-block">
        <ul id="bonusName">
          <li class="line"></li>
          <li class="line" v-for="i in nameList">
            <p class="p1">{{i.phoneNum}}</p>
            <p class="p2">
              连续签到
              <span>{{i.continueNum}}</span>天
            </p>
          </li>
        </ul>
      </div>
    </section>

    <section class="bonus-content">
      <div class="bonus-title">
        <span>活动规则</span>
      </div>
      <div class="content">
        <p>1.活动时间：2017年6月22日至7月31日</p>
        <p>2.进入奖金池条件：活动期间内，连续签到满30天及以上用户可进入奖金池</p>
        <p>3.所有进入奖金池的用户瓜分奖金池内的金额，连续签到总天数越多，奖励金额越高</p>
        <p>4.漏签会中断连续签到任务</p>
        <p>5.如活动期间内有多个连续签到记录，瓜分奖金时，取最大值</p>
        <p>6.奖励金额以对等的积分形式发放至众安账户，1人民币=100积分</p>
        <p>7.用户需要在活动结束的7天内点击领取，否则视为放弃</p>
        <p>8.如通过非法手段刷取任何形式的奖励，众安有权对违法所得奖励及账号进行冻结，并保留法律诉讼的权利</p>
        <p>9.众安在线财产保险股份有限公司保留本活动最终解释权</p>
        <p>10.关于活动任何其它疑问，请咨询全国统一服务热线：1010-9955，举报建议及投诉电话021-80399188。</p>
      </div>
    </section>

    <div class="dialog1" v-show="getSucc">
      <div class="block">
        <p class="p1">您已成功领取奖金</p>
        <p class="p2">积分已发放至您的账户</p>
        <div class="b"></div>
      </div>
      <div class="close" @click.prevent="getSucc=false"></div>
    </div>
  </div>
</template>
<script>
import service from '../api/service'

let numTime, nameTime
export default {
    data() {
        return {
            option: {},
            isAward: false, //活动是否开奖
            isGet: false,
            getSucc: false,
            start: 0,
            sumAmount: 0,
            involvePerson: 0, //平分人数
            currentListSize: 0,
            listSize: 0,
            liHeight: 0,
            nameList: [],
            nullDataBase: false,
            numLength: 0,
            numClass: [
                {
                    zero1: 'zero1', //速度
                    to: '' //数字
                },
                {
                    zero2: 'zero2',
                    to: ''
                },
                {
                    zero3: 'zero3',
                    to: ''
                },
                {
                    zero4: 'zero4',
                    to: ''
                },
                {
                    zero5: 'zero5',
                    to: ''
                },
                {
                    zero6: 'zero6',
                    to: ''
                },
                {
                    zero7: 'zero7', //最慢
                    to: ''
                }
            ]
        }
    },

    created() {},

    beforeMount() {
        document.title = '奖金池'
        window.bridge &&
            window.bridge.ready(bri => {
                bri.onJSInvokeResult('1', '奖金池')
            })
        clearInterval(numTime)
        this.getBonusInfo()
    },

    mounted() {
        clearInterval(numTime)
        this.getBonusInfo()
        clearInterval(nameTime)
        this.rollName()
    },
    methods: {
        getBonusInfo() {
            service.BonusGetActivityByAccount().then(
                data => {
                    if (data.success) {
                        this.isAward = data.obj.activity.award
                        this.involvePerson = data.obj.activity.involvePerson
                        this.sumAmount = data.obj.activity.sumAmount
                        if (!this.isAward) {
                            //未开奖
                            this.rollNum('unfinishList', this.sumAmount, false)
                        } else {
                            //开奖后
                            this.isGet = data.obj.person.get
                            if (this.isGet) {
                                if (data.obj.person.status == '2') {
                                    $('.btn-get').text('已领取')
                                    $('.btn-get').css('pointer-events', 'none')
                                }
                                this.rollNum('finishGet', data.obj.person.awardAmount, true)
                            } else {
                                this.rollNum('finishNoGet', data.obj.activity.perAmount, true)
                            }
                        }
                    } else {
                        _zax.ui.toast('查询失败', 2000, () => {})
                        location.href = '/myPlutuscat#/sign'
                    }
                },
                e => {
                    console.log(e)
                }
            )
        },

        getBonus() {
            service.GetBonusAjax().then(
                data => {
                    if (data && (data.returnMsg || data.returnMessage)) {
                        _zax.ui.toast(data.returnMsg || data.returnMessage, 2000, () => {})
                    }
                    if (data.success) {
                        this.getSucc = true
                        $('.btn-get').text('已领取')
                        $('.btn-get').css('pointer-events', 'none')
                    } else {
                        // if ('47' == data.code) {
                        //     _zax.ui.toast('您已重复领取', 2000, () => {})
                        // } else {
                        //     _zax.ui.toast('领取失败 请重试', 2000, () => {})
                        // }
                    }
                },
                e => {
                    _zax.ui.toast('查询失败', 2000, () => {})
                }
            )
        },

        rollNum(srcId, num, hasDot) {
            let Id = '#' + srcId
            num = num == undefined ? 0 : num
            num = hasDot
                ? num == 0
                    ? '000'
                    : num
                          .toFixed(2)
                          .toString()
                          .replace('.', '') + ''
                : num + ''
            num = num.length > 7 ? num.substr(num.length - 7, 7) : num
            let listSize = $(Id)
                .children('li')
                .size()
            if (listSize > num.length) {
                for (let a = 0; a < listSize - num.length; a++) {
                    $(Id)
                        .children('li')[0]
                        .remove()
                }
            }
            this.numLength = num.length
            for (let i = 0; i < this.numLength + 1; i++) {
                !(function(_i) {
                    numTime = setInterval(function() {
                        $($(Id).children('li')[_i]).addClass('to' + num.substr(_i, 1))
                    }, _i * 1000)
                })(i)
            }
        },

        rollName() {
            let self = this
            self.getNamelist()
            this.liHeight = parseInt($($('#bonusName li')[0]).height())
            var margintop = -this.liHeight
            $('#bonusName').css('top', margintop)

            nameTime = setInterval(function() {
                let me = self
                margintop--
                $('#bonusName').css('top', margintop)
                if (margintop == -(me.liHeight * (me.listSize - 4))) {
                    me.getNamelist()
                }
            }, 20)
            $('#bonusName').html()
        },

        getNamelist() {
            if (this.nullDataBase) {
                this.nameList = this.nameList.concat(this.nameList)
                this.listSize = this.listSize * 2
                return
            }
            service.GetActivityRecord(this.start, 12).then(
                data => {
                    if (data.success) {
                        if (data.rows.length > 0) {
                            this.start += 12
                            this.nameList = this.nameList.concat(data.rows)
                            this.currentListSize = data.rows.length
                            this.listSize = this.listSize + this.currentListSize
                        } else {
                            this.nameList = this.nameList.concat(this.nameList)
                            this.listSize = this.listSize * 2
                            this.nullDataBase = true
                        }
                    } else {
                        _zax.ui.toast('查询失败', 2000, () => {})
                    }
                },
                e => {
                    _zax.ui.toast('查询失败', 2000, () => {
                        clearInterval(this.timer)
                    })
                }
            )
        }
    },
    components: {}
}
</script>



// WEBPACK FOOTER //
// src/views/Bonus.vue